import { useGetUsermanagerCurrentQuery } from '../../../api'

export const useUser = useGetUsermanagerCurrentQuery
